import React from "react";
import { IconProps } from "./types";

function IconDoubleForwardArrow(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="icon">
        <path
          id="Icon (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9158 8.47162C14.1762 8.21127 14.1762 7.78916 13.9158 7.52881L9.47138 3.08437C9.21103 2.82402 8.78892 2.82402 8.52857 3.08437C8.26822 3.34472 8.26822 3.76683 8.52857 4.02718L12.5016 8.00022L8.52857 11.9733C8.26822 12.2336 8.26822 12.6557 8.52857 12.9161C8.78892 13.1764 9.21103 13.1764 9.47138 12.9161L13.9158 8.47162ZM3.24916 12.9161L7.6936 8.47162C7.95395 8.21127 7.95395 7.78916 7.6936 7.52881L3.24916 3.08437C2.98881 2.82402 2.5667 2.82402 2.30635 3.08437C2.046 3.34472 2.046 3.76683 2.30635 4.02718L6.27939 8.00022L2.30635 11.9733C2.046 12.2336 2.046 12.6557 2.30635 12.9161C2.5667 13.1764 2.98881 13.1764 3.24916 12.9161Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default IconDoubleForwardArrow;
